import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { formatDateTime } from '@/lib/format';
import type { Database } from '@archi/types/database.generated';

type Job = Database['public']['Tables']['render_jobs']['Row'];

const STATUS_COLOR: Record<Job['status'], string> = {
  queued: 'bg-muted text-muted-foreground',
  processing: 'bg-amber-100 text-amber-900 animate-pulse',
  succeeded: 'bg-emerald-100 text-emerald-900',
  failed: 'bg-destructive/10 text-destructive',
  canceled: 'bg-muted text-muted-foreground',
};

const TIER_LABEL: Record<Job['tier'], string> = {
  preview: 'Preview',
  standard: 'Standard',
  pro: 'Pro',
};

export const RenderCard: React.FC<{ job: Job; thumbUrl?: string }> = ({ job, thumbUrl }) => (
  <Link
    to={`/renders/${job.id}`}
    className="group block overflow-hidden rounded-lg border bg-card shadow-sm transition-shadow hover:shadow-md"
  >
    <div className="relative aspect-[4/3] bg-muted">
      {thumbUrl ? (
        <img
          src={thumbUrl}
          alt={`render ${job.id.slice(0, 8)}`}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      ) : job.status === 'processing' || job.status === 'queued' ? (
        <div className="absolute inset-0 bg-shimmer animate-shimmer" />
      ) : (
        <div className="absolute inset-0 grid place-items-center text-muted-foreground text-xs">
          sem preview
        </div>
      )}
      <span
        className={cn(
          'absolute right-2 top-2 rounded px-2 py-0.5 text-[10px] font-medium uppercase',
          STATUS_COLOR[job.status],
        )}
      >
        {job.status}
      </span>
    </div>
    <div className="flex items-center justify-between p-3 text-xs">
      <span className="text-muted-foreground">{formatDateTime(job.created_at)}</span>
      <span className="font-medium">{TIER_LABEL[job.tier]}</span>
    </div>
  </Link>
);
